module.exports = __webpack_public_path__ + "static/media/alena_thumb.cc8bc665.webp";